import { render, staticRenderFns } from "./vt-personnel-profile-image.vue?vue&type=template&id=93d63078&scoped=true&"
import script from "./vt-personnel-profile-image.ts?vue&type=script&lang=ts&"
export * from "./vt-personnel-profile-image.ts?vue&type=script&lang=ts&"
import style0 from "./vt-personnel-profile-image.scss?vue&type=style&index=0&id=93d63078&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d63078",
  null
  
)

export default component.exports